// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Loader = require("../../uikit/reason/atoms/Loader/Loader.bs.js");
var PageTitle = require("../../reason/common/PageTitle.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var PageUITitle = require("../../components/PageTitle/PageUITitle.bs.js");
var MarkupHelpers = require("../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
var ErrorComponent = require("../../reason/common/Error/ErrorComponent.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var HighlightSection__Jsx3 = require("../../uikit/reason/atoms/Sections/HighlightSection__Jsx3.bs.js");
var ChapterMembersListRelay = require("./ChapterMembersListRelay.bs.js");
var MarkupHelpers$1 = require("components/MarkupHelpers");
var ChapterMembersListRelayQueryParams = require("./ChapterMembersListRelayQueryParams.bs.js");
var ChapterMembersPageRelayQuery_graphql = require("../../__generated__/ChapterMembersPageRelayQuery_graphql.bs.js");

var convertVariables = ChapterMembersPageRelayQuery_graphql.Internal.convertVariables;

var convertResponse = ChapterMembersPageRelayQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = ChapterMembersPageRelayQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, ChapterMembersPageRelayQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, ChapterMembersPageRelayQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(ChapterMembersPageRelayQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(ChapterMembersPageRelayQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(ChapterMembersPageRelayQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(ChapterMembersPageRelayQuery_graphql.node, convertVariables);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

var error = JsxRuntime.jsx(ErrorComponent.make, {
      message: "We encountered a problem while getting membership data. Please refresh or try again later."
    });

function ChapterMembersPageRelay$Page(props) {
  var match = ChapterMembersListRelayQueryParams.use();
  var queryParams = match[0];
  var match$1 = React.useState(function () {
        return queryParams;
      });
  var initialQueryParams = match$1[0];
  var data = use({
        after: initialQueryParams.after,
        before: initialQueryParams.before,
        search: initialQueryParams.search
      }, undefined, undefined, undefined);
  var match$2 = data.currentChapterV5;
  if (match$2 === undefined) {
    return error;
  }
  var memberCount = match$2.memberCount;
  var brokerageCount = match$2.brokerageCount;
  return JsxRuntime.jsx(MarkupHelpers.Container.make, {
              children: JsxRuntime.jsxs(MarkupHelpers$1.ContentBox, {
                    paddingFull: true,
                    hasShadow: true,
                    children: [
                      JsxRuntime.jsx(PageUITitle.make, {
                            title: "Member Directory"
                          }),
                      memberCount !== undefined && brokerageCount !== undefined ? JsxRuntime.jsx(HighlightSection__Jsx3.make, {
                              background: "Muted",
                              children: Caml_option.some("There are " + memberCount.toString() + " top agent members in TAN " + match$2.displayName + ". These agents represent " + brokerageCount.toString() + " different brokerages.")
                            }) : JsxRuntime.jsx(HighlightSection__Jsx3.make, {
                              background: "Danger",
                              children: "We encountered a problem while getting membership stats for this chapter... Please refresh or try again later."
                            }),
                      JsxRuntime.jsx(ChapterMembersListRelay.make, {
                            chapter: match$2.fragmentRefs
                          })
                    ]
                  })
            });
}

var Page = {
  make: ChapterMembersPageRelay$Page
};

function ChapterMembersPageRelay(props) {
  return JsxRuntime.jsxs(React.Suspense, {
              children: [
                JsxRuntime.jsx(PageTitle.make, {
                      title: "Member Directory"
                    }),
                JsxRuntime.jsx(ChapterMembersPageRelay$Page, {})
              ],
              fallback: Caml_option.some(JsxRuntime.jsx(Loader.make, {}))
            });
}

var make = ChapterMembersPageRelay;

var $$default = ChapterMembersPageRelay;

exports.Query = Query;
exports.error = error;
exports.Page = Page;
exports.make = make;
exports.default = $$default;
exports.__esModule = true;
/* use Not a pure module */
